import isSameDayLib from 'date-fns/isSameDay'

export const isSameDay = (firstDate, secondDate) =>
  isSameDayLib(new Date(firstDate), new Date(secondDate))
